const hostName = {
  development: 'https://aluwebsite-develop.web.app',
  staging: 'https://aluwebsite-staging.web.app',
  production: 'https://aluwebsite.web.app'
}[process.env.REACT_APP_ENV]

export {
  hostName
}